import React, { useCallback, useMemo } from 'react'
import { Row, Col } from 'react-grid-system'
import DateInput from '../../common/form/fields/dateInput/dateInput'
import Dropdown from '../../common/form/fields/dropdown/dropdown'
import { BorrowViewProps } from '../actionsWorkflow.type'
import { Option } from '../../common/form/fields/dropdown/types'
import { Input } from '../../common/form/fields'

export const BorrowView = ({
   handleDropdownChange,
   handleDateChange,
   locationOptions,
   cartOptions,
   enableLocationTracking,
   handleCommentChange,
}: BorrowViewProps) => {
   const handleLocationChange = useCallback(
      (option: Option) => handleDropdownChange('Location', option),
      [handleDropdownChange]
   )

   const handleDueBackChange = useCallback(
      (date) => handleDateChange('DueBack', date),
      [handleDateChange]
   )

   const handleCommentFieldChange = useCallback(
      (comment) => handleCommentChange('Comment', comment),
      [handleCommentChange]
   )

   const selectedDueBackDate = useMemo(() => {
      if (cartOptions?.dueBackDate) {
         return new Date(Date.parse(cartOptions?.dueBackDate))
      }
      return null
   }, [cartOptions?.dueBackDate])

   return (
      <>
         <Row gutterWidth={20}>
            {enableLocationTracking && (
               <Col md={6} lg={6}>
                  <Dropdown
                     name="NewLocation"
                     onChange={handleLocationChange}
                     options={locationOptions}
                     id="NewLocation"
                     label="New Location (optional)"
                     placeholder="New Location (optional)"
                     isMulti={false}
                  />
               </Col>
            )}
            <Col md={6} lg={6}>
               <DateInput
                  id="DueBackDate"
                  label="Due back (optional)"
                  onChange={handleDueBackChange}
                  selectedDate={selectedDueBackDate}
                  minDate={new Date()}
               />
            </Col>
            {!enableLocationTracking && (
               <Col md={6}>
                  <Input
                     id="Comment"
                     label="Comment (optional)"
                     onChange={handleCommentFieldChange}
                  />
               </Col>
            )}
         </Row>
         {/* if location tracking is enabled, put comment on another row */}
         {enableLocationTracking && (
            <Row>
               <Col md={12}>
                  <Input
                     id="Comment"
                     label="Comment (optional)"
                     onChange={handleCommentFieldChange}
                  />
               </Col>
            </Row>
         )}
      </>
   )
}
